export const checkDayAndNight = (workSchedule = []) => {
  return workSchedule.some(({ workDays, workTime }) => {
    if (workTime?.toLowerCase() === 'круглосуточно') return true;

    if (!workDays || !workTime) return false;

    return workDays === 'Пн - Вс' && workTime === '00:00 - 23:59';
  });
};

export const getLineIds = (products = []) => {
  return products.reduce((a, { lineIds = [] } = {}) => {
    lineIds.forEach(id => a.push(id)); // производительнее, чем spread
    return a;
  }, []);
};
